var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Icon, ICON_SIZES } from "../Icon";
import { Text, TEXT_VIEW } from "../Text";
import { View, VIEW_ALIGN, SPACE_FILL } from "../View";
import { StackView, STACK_ALIGN, STACK_GAP } from "../StackView";
import { createUIElement } from "../helpers";
import { ErrorStatusIcon } from "../icons";
var StyledText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    white-space: pre-line;\n    overflow: hidden;\n"], ["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    white-space: pre-line;\n    overflow: hidden;\n"])));
var StyledStackView = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-flex;\n    padding-top: 1px;\n    padding-bottom: 1px;\n"], ["\n    display: inline-flex;\n    padding-top: 1px;\n    padding-bottom: 1px;\n"])));
export var ErrorMessage = createUIElement('ErrorMessage', function (_a, ref) {
    var className = _a.className, children = _a.children, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StyledStackView, __assign({}, rest, { testId: rest['data-selector-id'] || 'errormessage-wrapper', className: "vm-ErrorMessage " + className, gap: STACK_GAP.s, align: STACK_ALIGN.start, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(Icon, { "data-selector-id": "errormessage-icon", size: ICON_SIZES.m, src: React.createElement(ErrorStatusIcon, null) }),
        React.createElement(View, { align: VIEW_ALIGN.center, spaceFill: SPACE_FILL.all },
            React.createElement(StyledText, { "data-selector-id": "errormessage-text", view: TEXT_VIEW.error }, children))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=ErrorMessage.js.map